import { render, staticRenderFns } from "./communityFeeSummaryList.vue?vue&type=template&id=3f3b0bd8&scoped=true"
import script from "./communityFeeSummaryList.vue?vue&type=script&lang=js"
export * from "./communityFeeSummaryList.vue?vue&type=script&lang=js"
import style0 from "./communityFeeSummaryList.vue?vue&type=style&index=0&id=3f3b0bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b0bd8",
  null
  
)

export default component.exports